module.exports = __webpack_public_path__ + "static/media/298539.dcb862f6.png";